import { Injectable } from '@angular/core';
import Globals from '../base/interfaces/IGlobals';

@Injectable({
	providedIn: 'root'
})
export class SessionStorageService {

	constructor() { }
	/**
	 * Obtiene la información de la variable local SessionInfo dentro de window.sessionstorage
	 * @author Bvelez
	 */
	obtenerInfoSesion(): Globals {
		let globals: Globals = new Globals();
		let datosEnLocalStorage: string;
		try {
			datosEnLocalStorage = window.sessionStorage.getItem('SessionInfo') || '';
			globals = JSON.parse(datosEnLocalStorage) as Globals;
		} catch (error) {
			console.log(error);
		}
		return globals;
	}
	/**
	 * Modifica la información de la variable local SessionInfo dentro de window.sessionstorage
	 * @author Bvelez
	 */
	modificarInfoSesion(datos: Globals): void {
		window.sessionStorage.setItem('SessionInfo', JSON.stringify(datos));
	}
	/**
	 * Elimina la variable local SessionInfo dentro de window.sessionstorage
	 * @author Bvelez
	 */
	eliminarInfoSesion(): void {
		window.sessionStorage.removeItem('SessionInfo');
	}

	getNewGUIDString(): string {
		let d = new Date().getTime();
		if (window.performance && typeof window.performance.now === "function") {
			d += performance.now(); //use high-precision timer if available
		}
		return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
			let r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
		});
	}
}
